import React from 'react';
import { Box } from '@mui/material';

const Sparkline = ({ data, width = 40, height = 20, color = '#47BDC6' }) => {
  if (!data || data.length === 0) {
    return <Box sx={{ width, height, display: 'inline-block' }} />;
  }

  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  
  // Scale values to height
  const points = data.map((val, idx) => {
    const x = (idx / (data.length - 1)) * width;
    const y = height - ((val - min) / range) * height;
    return `${x},${y}`;
  }).join(' ');

  return (
    <svg width={width} height={height} style={{ display: 'inline-block', verticalAlign: 'middle' }}>
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="2"
        points={points}
      />
    </svg>
  );
};

export default Sparkline;

